import { combineReducers } from 'redux';

import view from './reducers/view';
import wordGroupsReducer from './reducers/wordGroupsReducer';
import wordListReducer from './reducers/wordListReducer';
import levelReducer from './reducers/levelReducer';
import questionReducer from './reducers/questionReducer';
import alexReducer from './reducers/alexReducer';
import targetReducer from './reducers/targetReducer';
import onboardingReducer from './reducers/onboardingReducer';
import instructionReducer from './reducers/instructionReducer';
import dropzoneReducer from './reducers/dropzoneReducer';

const reducers = combineReducers({
  view,
  wordGroups: wordGroupsReducer,
  wordList: wordListReducer,
  levelReducer,
  questionReducer,
  alexState: alexReducer,
  target: targetReducer,
  onboarding: onboardingReducer,
  instruction: instructionReducer,
  dropzoneReducer,
});

export default reducers;
